import cn from "classnames";

import {Message} from "@pg-design/message-module";
import {useFancyUnmount, useIsMounted} from "@pg-mono/hooks";
import {noop} from "@pg-mono/nodash";

import type {INotification} from "../types/INotification";
import {CloseIcon} from "./CloseIcon";

import * as styles from "./Notification.module.css";

interface IProps {
    notification: INotification;
    removeNotification: () => void;
}

export const Notification = (props: IProps) => {
    const isMounted = useIsMounted();

    const {unmount, runUnmountAnimation} = useFancyUnmount(2000, props.removeNotification, props.notification.timeout);

    return (
        <li className={cn(styles["notification"], isMounted ? styles.opacity100 : styles.opacity0, runUnmountAnimation && styles.notificationUnmountAnimation)}>
            <Message type={props.notification.type} className={styles.notificationType}>
                <Message.Content type={props.notification.type} className={styles.notificationContentContainer}>
                    {props.notification.content}
                </Message.Content>
                <div className={styles.notificationCloseContainer}>
                    <div className={styles.notificationClose} onClick={unmount}>
                        <CloseIcon fill={props.notification.type === "failure" ? "#ffffff" : noop()} />
                    </div>
                </div>
            </Message>
        </li>
    );
};
import cn from "classnames";

import {Message} from "@pg-design/message-module";
import {useFancyUnmount, useIsMounted} from "@pg-mono/hooks";
import {noop} from "@pg-mono/nodash";

import type {INotification} from "../types/INotification";
import {CloseIcon} from "./CloseIcon";

import * as styles from "./Notification.module.css";

interface IProps {
    notification: INotification;
    removeNotification: () => void;
}

export const Notification = (props: IProps) => {
    const isMounted = useIsMounted();

    const {unmount, runUnmountAnimation} = useFancyUnmount(2000, props.removeNotification, props.notification.timeout);

    return (
        <li className={cn(styles["notification"], isMounted ? styles.opacity100 : styles.opacity0, runUnmountAnimation && styles.notificationUnmountAnimation)}>
            <Message type={props.notification.type} className={styles.notificationType}>
                <Message.Content type={props.notification.type} className={styles.notificationContentContainer}>
                    {props.notification.content}
                </Message.Content>
                <div className={styles.notificationCloseContainer}>
                    <div className={styles.notificationClose} onClick={unmount}>
                        <CloseIcon fill={props.notification.type === "failure" ? "#ffffff" : noop()} />
                    </div>
                </div>
            </Message>
        </li>
    );
};
